import { MutationTuple, useMutation } from '@apollo/client';
import { SaveTimesheetInput, SaveTimesheetPayload } from '@bechtel/types';
import { SAVE_TIMESHEET } from '@bechtel/client-gql';

export function useSaveTimeSheet(
  onActionCompleted?: () => void
): MutationTuple<{ saveTimesheet: SaveTimesheetPayload }, { input: SaveTimesheetInput }> {
  const response = useMutation<{ saveTimesheet: SaveTimesheetPayload }, { input: SaveTimesheetInput }>(SAVE_TIMESHEET, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
  });
  return response;
}
